import { Box } from "@mui/material";
import CelebrationScreen from "components/missions/CelebrationScreen";
import ContentAdmin from "../../../../components/contentAdmin";
import useMission from "../../hooks/useMission";

function MapContainerFinish()
{
	const missionContext = useMission();

	// Handles
	function onClickNextStep()
	{
		missionContext.setStep((currentStep) => currentStep + 1);
	}

	// Render
	return (
		<Box className="main__content" sx={{ alignItems: "center" }}>
			<CelebrationScreen
				content={<ContentAdmin keyContent="contentMissionThree" keyText="screen_17_text" defaultValue="{NAME}, I hope you feel lighter already. Let’s create more clarity!" position="left" isDescription />}
				buttonText="Let’s do it!"
				onClickButton={() => onClickNextStep()}
				sx={{
					color: "primary.main",

					"& .CelebrationScreen-content":
					{
						textShadow: "unset"
					}
				}}
			/>
		</Box>
	);
}

export default MapContainerFinish;
